export default class StickyNavigation {
	private readonly header: HTMLDivElement;
	private readonly stickyNavigation: HTMLDivElement;

	constructor() {
		this.header = document.querySelector('.benefits') || document.querySelector('.lp-header');
		this.stickyNavigation = document.querySelector('.header.sticky');

		if (this.header && this.stickyNavigation) {
			window.addEventListener('scroll', () => this.onScroll(), { passive: true });
			this.onScroll();
			this.stickyNavigation.setAttribute('inert', '');
		}
	}

	private onScroll(): void {
		const rect: DOMRect = this.header.getBoundingClientRect();
		if (rect.height + rect.top > 0) {
			this.stickyNavigation.classList.remove('is-visible');
			this.stickyNavigation.setAttribute('inert', '');
		} else {
			this.stickyNavigation.classList.add('is-visible');
			this.stickyNavigation.removeAttribute('inert');
		}
	}
}
